import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/experiments/compare");

export const Route = createFileRoute("/experiments/compare")({
  head: () => ({
    meta: [
      { title: "Compare scenarios — LevelLoad" },
      {
        name: "description",
        content: "Metric deltas and overlay differences between two planning scenarios.",
      },
      { property: "og:title", content: "Compare scenarios — LevelLoad" },
      {
        property: "og:description",
        content: "Metric deltas and overlay differences between two planning scenarios.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
